<template>
<v-card flat class="mt-2 mr-2">
    <v-snackbar v-model="snackbar.active" :color="snackbar.color" :timeout="4000" top >    
        <span> {{snackbar.message}} </span>
        <v-btn text @click="snackbar.active = false">Close</v-btn>
    </v-snackbar>    
    <v-tabs v-model="tab" background-color="#296B74" color="white" dark centered fixed-tabs>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-1">
            <v-icon left>mdi-format-list-bulleted</v-icon>
            Coleções
        </v-tab>
        <v-tab href="#tab-2">
            <v-icon left>mdi-shape</v-icon>
            Categoria
        </v-tab>
        <v-tab href="#tab-3">
            <v-icon left>mdi-cart</v-icon>
            Produtos
        </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item :key="1" :value="'tab-1'" >
        <v-card flat>
            <v-card-text>
                <listComponent :list="colection" :key="key" v-on:listEdit="listEdit($event,'colecoes')" v-on:listDisable="disableEdit($event,'colecoes')" v-on:loadMessage="loadMessage"/>
                <v-divider></v-divider>
                <createCollection v-on:collectionAdded="refreshCol" v-on:loadMessage="loadMessage"/>              
            </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="2" :value="'tab-2'" >
        <v-card class="mx-auto">
            <v-toolbar flat >
                <v-col cols="3">
                    <v-select 
                        v-model="selColection" 
                        :items="colection" 
                        label="Selecione uma Coleção" 
                        item-text="nome" 
                        return-object
                        style="margin-top: 25px; !important"
                        @change="changeColection()">
                </v-select>     
                </v-col>           
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                    <listComponent :list="items" :key="key" v-on:listEdit="listEdit($event,'categorias')" v-on:listDisable="disableEdit($event,'categorias')" v-on:loadMessage="loadMessage"/>
                    <v-divider></v-divider> 
                    <createCategory v-on:categoryAdded="changeColection" v-on:loadMessage="loadMessage"/>               
            </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item :key="3" :value="'tab-3'" >
        <v-card class="mx-auto">
            <v-toolbar flat >
                <v-col cols="3">
                    <v-select 
                        v-model="selectedCategory" 
                        :items="items" 
                        label="Selecione uma Categoria" 
                        item-text="nome" 
                        return-object
                        style="margin-top: 25px; !important"
                        @change="selectItem()">
                </v-select>     
                </v-col>           
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text>
                    <listComponent v-model="selectedProd" :list="prodList" :key="key" v-on:listSelect="selectedProd = $event" v-on:listEdit="listEdit($event,'produtos')" v-on:listDisable="disableEdit($event,'produtos')" v-on:loadMessage="loadMessage"/>
                    <v-divider></v-divider> 
                    <CreateProd :selCatId="selectedCategory.id" :selCat="selectedCategory.nome" v-on:productAdded="loadProducts" v-on:loadMessage="loadMessage"/>            
            </v-card-text>
        </v-card>
      </v-tab-item>            
    </v-tabs-items>
  </v-card>
</template>

<script>
import listComponent from "@/components/general/listComponent"
import createCollection from '@/modules/products/collection/createCollection'
import createCategory from '@/modules/products/category/createCategory'
import CreateProd from '@/modules/products/products/createProducts'
import {files, db} from "@/main"
import store from "@/store"
import dbFunctions from '@/dbFunctions'

export default {
    components: {
        listComponent,
        createCollection,
        createCategory,
        CreateProd,
        // expand
    },
    data: () => ({
        enabled: true,
        dragging: false,
        items: [],
        selColection: [],
        selectedProd: [],
        prodList: [],
        miniVariant: false,
        selectedCategory: [],
        data: [], 
        key: 0, 
        key2: 0,
        tab: null,    
        publicPath: "https://quoon-br.web.app/",
        snackbar: {
            'active':false,
            'color':'success',
            'message':'Deu Certo'
        }
    }),
    created(){
        this.getDataInfo = dbFunctions.getDataInfo

        this.refreshCol()
        this.selColection = this.colection.filter((col) => {
            return col.default == true
        })[0]
        this.loadProducts()
        console.log("listComponenet", process)
    },
    methods:{
        loadMessage(value){
            this.snackbar = value
        },
        listEdit(value, caller){
            console.log('listEdit',value, caller)            
            if (caller == 'colecoes') {
                this.refreshCol()
                console.log("entrei")
            } else if(caller == 'categorias')
                this.changeColection()
            else if(caller == 'produtos')
                this.loadProducts()
            
        },
        disableEdit(value, caller){
            // console.log("disable", value,caller)

            let docRef = db.collection(caller).doc(value.id)
            docRef.update({ativo: !value.ativo}).then(async() => {
                await this.reloadData(localStorage.sessionId)
                if(caller == 'colecoes'){
                    this.colection = this.$store.getters.data.data.colecoes
                    this.key += 1  
                } else if(caller == 'categorias'){
                    this.changeColection(this.selColection)
                } else if(caller == 'produtos'){
                    console.log(this.selectedCategory)
                    this.selectItem(this.selectedCategory)
                }
                let success = {
                    'active':true,
                    'color':'success',
                    'message':'Atualizado Com Sucesso'
                }                 
                this.loadMessage(success)
            }).catch(function(error) {
                let errorMessage = {
                    'active':true,
                    'color':'error',
                    'message': error
                }          
                console.error('Error to updating Category: ' + error)
                this.$emit("loadMessage",errorMessage)                
            })
        },
        changeColection(value = null){  
            if (value != null)
                this.selColection = value

            console.log("ChangeColection 1", this.selColection)

            this.items = []
            this.data = this.$store.getters.data.data
            this.items.push(this.data.categorias.filter((cat) => {
                let teste = cat.colecao.filter((col) => {return col.id.match(this.selColection.id)})
                return teste.length > 0
            }))

            console.log("ChangeColection", this.items)
            this.items = this.items[0]
            // this.prodList = []
            this.key += 1
       }, 
       selectItem(value = null){
            if (value != null)
                this.selectedCategory = value

            this.loadProducts();
            this.key += 1
       },
       refreshCol : function(){
            this.data = this.$store.getters.data.data
            this.colection = this.data.colecoes
            this.items.push(this.data.categorias.filter((cat) => {
                return cat.colecao.filter((col) => {return col.id.match(this.selColection)})
            }))
            this.items = this.items[0]
            this.key += 1
        },
        async loadProducts(){
            console.log("categoria Id", this.selectedCategory)
            let products = this.$store.getters.data.data.produtos
            let ref = files.ref();
            
            if(typeof this.selectedCategory.id != "undefined" ){
                this.prodList = []
                let categoryId = this.selectedCategory.id;    
                this.prodList.push(products.filter((prod) => {
                    return prod.categoria.id.match(categoryId)            
                })) 
                this.selCategory = this.$store.getters.data.data.categorias.filter((cat) => {
                                    return cat.id.match(categoryId)
                                    })[0]  
                this.prodList = this.prodList[0]                                  
            } else 
                this.prodList = products   

            console.log(this.prodList)
            let each = []
            this.prodList.forEach(async (item) => {
            // console.log("item",item,ref)
                let change = item
                if (typeof item.imagens != 'undefined'){
                await ref.child(item.imagens[0]).getDownloadURL().then(function(url){
                    change.img = url
                })              
                } else {
                change.img = this.publicPath+'semfoto.gif'
                }
                each.push(change)
            })
            this.prodList = each
            console.log(each, this.prodList)
            this.key += 1
        },
        async reloadData(companyId){
            let dataStore = await this.getDataInfo(companyId)
            store.dispatch("fetchData",dataStore)
            // console.log("reloadData", dataStore)
        },                   
    }     
};
</script>